import { fetchServicePartnerCollections } from "@/lib/api/resources/servicePartnerCollections";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Table } from "@/components/v2";
import { servicePartnerCollectionColumns } from "./lib/constants/servicePartnerCollectionColumns";
import { Space } from "antd";
import { Link } from "react-router-dom";
import { Button } from "@rumbledirect/ui";
import { PlusOutlined } from "@ant-design/icons";

export const ServicePartnersCollectionList = () => {
  const [page, setPage] = useState<number>(1);

  const servicePartnerCollectionsQuery = useQuery({
    queryKey: ["service-partner-collections", page],
    queryFn: () => fetchServicePartnerCollections({ page }),
  });

  return (
    <>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/service-partners/collections/create">
          <Button icon={<PlusOutlined />}>Nieuw subnetwerk</Button>
        </Link>
      </Space>
      <Table
        columns={servicePartnerCollectionColumns}
        dataSource={servicePartnerCollectionsQuery.data?.member}
        loading={servicePartnerCollectionsQuery.isLoading}
        pagination={{
          pageSize: 15,
          total: servicePartnerCollectionsQuery.data?.totalItems,
          showSizeChanger: false,
          onChange: (page) => setPage(page),
        }}
        rowKey="id"
      />
    </>
  );
};
